import * as stylex from "@stylexjs/stylex";
import type { AccountAgent, AccountUser } from "./account-records";
import { PersonCircle } from "./person-circle";
import { styles } from "./account-avatar.styles";

function AgentCircleView({
  agent,
  overlapping = false,
}: {
  readonly agent: Pick<AccountAgent, "label" | "initial" | "avatar">;
  readonly overlapping?: boolean;
}) {
  return (
    <span
      title={agent.label}
      {...stylex.props(styles.circle, overlapping && styles.overlap)}
    >
      {agent.avatar ? (
        <img src={agent.avatar} alt="" {...stylex.props(styles.picture)} />
      ) : (
        agent.initial
      )}
    </span>
  );
}

export function AccountPairView({
  user,
  agent,
}: {
  readonly user: AccountUser | null;
  readonly agent: Pick<AccountAgent, "label" | "initial" | "avatar">;
}) {
  return (
    <span {...stylex.props(styles.pair)}>
      <PersonCircle user={user} paired />
      <AgentCircleView agent={agent} overlapping />
    </span>
  );
}
